/**
 * Meta Pixel browser-side helper.
 *
 * Loads the fbq() script on demand once we know the pixel id from CMS,
 * fires PageView on every route change, and exposes track() for ad-hoc events.
 */

let _initializedPixelId = null;

function _injectScript() {
    if (window.fbq) return;
    /* eslint-disable */
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js",
    );
    /* eslint-enable */
}

export function initPixel(pixelId) {
    if (!pixelId) return;
    if (_initializedPixelId === pixelId) return;
    _injectScript();
    if (window.fbq) {
        window.fbq("init", pixelId);
        _initializedPixelId = pixelId;
    }
}

export function pageView() {
    if (window.fbq) window.fbq("track", "PageView");
}

export function track(event, params = {}) {
    if (window.fbq) window.fbq("track", event, params);
}

export function trackCustom(event, params = {}) {
    if (window.fbq) window.fbq("trackCustom", event, params);
}
